<div *ngIf="isLoading || isDeleteSuccess" class="overlay">
  <div class="spinner"></div>
  <p class="text-load">&nbsp;&nbsp; Loading...</p>
</div>

<div [class.blur]="isLoading">

<div class="draft-success-toast" *ngIf="successToastMessage">
  <mat-icon class="toast-check">check_circle</mat-icon>
  <div class="toast-text">
    <div class="toast-title">Success</div>
    <div class="toast-body">{{ successToastMessage }}</div>
  </div>
  <mat-icon class="toast-close" (click)="closeSuccessToast()">close</mat-icon>
</div>

<div class="breadcrumb-bar">
  <div class="breadcrumb">
    <span class="breadcrumb-current">Review Management</span>
  </div>
</div>

  <main class="page-content">
    <section class="content-card">
      <!--<h1 class="page-title">{{ pageTitle }}</h1>
     <p class="page-copy">Manage and track review lifecycle activities from this section.</p> -->

      <div class="header-bar">

        <div class="title-with-filter">
          <h2 class="title">Review Listing</h2>
          <button *ngIf="hasDashboardFilter" class="btn-clear-filter" (click)="clearDashboardFilter()">
            <mat-icon>filter_alt_off</mat-icon> Clear Filter
          </button>
        </div>

        <div class="header-actions">
          <span class="export-text" [class.disabled]="isExporting" (click)="exportVisible()">Export Visible
            <span class="tooltip-container" (click)="$event.stopPropagation()">
              <mat-icon class="icon-info">info_outline</mat-icon>
              <span class="tooltip-text">Exports all rows for the columns currently visible.</span>
            </span>
          </span>

          <button class="btn-outline" (click)="exportAll()" [disabled]="isExporting">
            Export All
            <span class="tooltip-container" (click)="$event.stopPropagation()">
              <mat-icon class="icon-info">info_outline</mat-icon>
              <span class="tooltip-text">Export all review records with all available system columns.</span>
            </span>
          </button>

          <button class="btn-primary" (click)="navigateToPlanning()">
            + Add New Review
          </button>
        </div>

      </div>

      <!-- Search -->
      <div class="search-bar">
        <input type="text" placeholder="Search Review" [(ngModel)]="searchText" (ngModelChange)="currentPage = 1" />
        <span class="search-icon"><mat-icon>search</mat-icon></span>
        <mat-icon class="filter-icon" (click)="toggleFilterPanel()">filter_alt</mat-icon>

        <!-- Dropdown panel -->
        <div class="filter-dropdown" *ngIf="isFilterOpen">
          <div class="filter-header">
            <span>Column Selector</span>
            <a class="clear" (click)="clearAll()">Clear All</a>
            <a class="select" (click)="selectAll()">Select All</a>
            <mat-icon (click)="toggleFilterPanel()">close</mat-icon>
          </div>

          <div class="filter-search">
            <span class="search-icon-column"><mat-icon class="search-column">search</mat-icon></span>
            <input type="text" placeholder="Search" [(ngModel)]="columnSearchText" />
          </div>

          <div class="filter-section-group">
            <div class="filter-section-header" (click)="toggleBasicSection()">
              <span>Review Basic Details</span>
              <mat-icon>{{ basicExpanded ? 'expand_less' : 'expand_more' }}</mat-icon>
            </div>
            <div class="filter-section-body" *ngIf="basicExpanded">
              <label *ngFor="let col of filteredBasicColumns()" class="filter-checkbox">
                <input type="checkbox" [(ngModel)]="col.visible" />
                <span class="checkbox-custom"></span>
                <span class="checkbox-label">{{ col.label }}</span>
              </label>
            </div>
          </div>

          <div class="filter-section-group">
            <div class="filter-section-header" (click)="toggleScheduleSection()">
              <span>Schedule</span>
              <mat-icon>{{ scheduleExpanded ? 'expand_less' : 'expand_more' }}</mat-icon>
            </div>
            <div class="filter-section-body" *ngIf="scheduleExpanded">
              <label *ngFor="let col of filteredScheduleColumns()" class="filter-checkbox">
                <input type="checkbox" [(ngModel)]="col.visible" />
                <span class="checkbox-custom"></span>
                <span class="checkbox-label">{{ col.label }}</span>
              </label>
            </div>
          </div>

          <div class="filter-footer">
            Total Columns: <b>{{ totalColumnCount() }}</b> &nbsp;&nbsp; Visible: <b>{{ visibleColumnCount() }}</b>
          </div>
        </div>

      </div>

      <div class="table-container">
        <table class="custom-table">
          <thead>
            <tr>
              <th *ngIf="isColumnVisible('id')" (click)="sort('id')" [class.active]="sortColumn === 'id'">
                <span class="th-content">
                  Review ID
                  <span class="material-symbols-outlined arrow-icon">
                    {{ getSortIcon('id') }}
                  </span>
                  <mat-icon class="col-filter-icon" [class.active]="hasActiveFilter('id')"
                    (click)="toggleColumnFilter('id', $event)">filter_alt</mat-icon>
                </span>
                <ng-container *ngTemplateOutlet="colFilter; context: { col: 'id' }"></ng-container>
              </th>

              <th *ngIf="isColumnVisible('name')" (click)="sort('name')" [class.active]="sortColumn === 'name'">
                <span class="th-content">
                  Review Name
                  <span class="material-symbols-outlined arrow-icon">
                    {{ getSortIcon('name') }}
                  </span>
                  <mat-icon class="col-filter-icon" [class.active]="hasActiveFilter('name')"
                    (click)="toggleColumnFilter('name', $event)">filter_alt</mat-icon>
                </span>
                <ng-container *ngTemplateOutlet="colFilter; context: { col: 'name' }"></ng-container>
              </th>

              <th *ngIf="isColumnVisible('employee')" (click)="sort('employee')"
                [class.active]="sortColumn === 'employee'">
                <span class="th-content">
                  Employee Name
                  <span class="material-symbols-outlined arrow-icon">
                    {{ getSortIcon('employee') }}
                  </span>
                  <mat-icon class="col-filter-icon" [class.active]="hasActiveFilter('employee')"
                    (click)="toggleColumnFilter('employee', $event)">filter_alt</mat-icon>
                </span>
                <ng-container *ngTemplateOutlet="colFilter; context: { col: 'employee' }"></ng-container>
              </th>

              <th *ngIf="isColumnVisible('status')" (click)="sort('status')" [class.active]="sortColumn === 'status'">
                <span class="th-content">
                  Current Status
                  <span class="material-symbols-outlined arrow-icon">
                    {{ getSortIcon('status') }}
                  </span>
                  <mat-icon class="col-filter-icon" [class.active]="hasActiveFilter('status')"
                    (click)="toggleColumnFilter('status', $event)">filter_alt</mat-icon>
                </span>
                <ng-container *ngTemplateOutlet="colFilter; context: { col: 'status' }"></ng-container>
              </th>

              <th *ngIf="isColumnVisible('year')" (click)="sort('year')" [class.active]="sortColumn === 'year'">
                <span class="th-content">
                  Proposed Year
                  <span class="material-symbols-outlined arrow-icon">
                    {{ getSortIcon('year') }}
                  </span>
                  <mat-icon class="col-filter-icon" [class.active]="hasActiveFilter('year')"
                    (click)="toggleColumnFilter('year', $event)">filter_alt</mat-icon>
                </span>
                <ng-container *ngTemplateOutlet="colFilter; context: { col: 'year' }"></ng-container>
              </th>

              <th *ngIf="isColumnVisible('client')" (click)="sort('client')" [class.active]="sortColumn === 'client'">
                <span class="th-content">
                  Master Client Name
                  <span class="material-symbols-outlined arrow-icon">
                    {{ getSortIcon('client') }}
                  </span>
                  <mat-icon class="col-filter-icon" [class.active]="hasActiveFilter('client')"
                    (click)="toggleColumnFilter('client', $event)">filter_alt</mat-icon>
                </span>
                <ng-container *ngTemplateOutlet="colFilter; context: { col: 'client' }"></ng-container>
              </th>

              <th *ngIf="isColumnVisible('project')" (click)="sort('project')"
                [class.active]="sortColumn === 'project'">
                <span class="th-content">
                  D&T Project Name
                  <span class="material-symbols-outlined arrow-icon">
                    {{ getSortIcon('project') }}
                  </span>
                  <mat-icon class="col-filter-icon" [class.active]="hasActiveFilter('project')"
                    (click)="toggleColumnFilter('project', $event)">filter_alt</mat-icon>
                </span>
                <ng-container *ngTemplateOutlet="colFilter; context: { col: 'project' }"></ng-container>
              </th>

              <th *ngIf="isColumnVisible('contract')" (click)="sort('contract')"
                [class.active]="sortColumn === 'contract'">
                <span class="th-content">
                  Contract Number
                  <span class="material-symbols-outlined arrow-icon">
                    {{ getSortIcon('contract') }}
                  </span>
                  <mat-icon class="col-filter-icon" [class.active]="hasActiveFilter('contract')"
                    (click)="toggleColumnFilter('contract', $event)">filter_alt</mat-icon>
                </span>
                <ng-container *ngTemplateOutlet="colFilter; context: { col: 'contract' }"></ng-container>
              </th>

              <th *ngIf="isColumnVisible('additionalContract')" (click)="sort('additionalContract')"
                [class.active]="sortColumn === 'additionalContract'">
                <span class="th-content">
                  Additional Contract Number
                  <span class="material-symbols-outlined arrow-icon">
                    {{ getSortIcon('additionalContract') }}
                  </span>
                  <mat-icon class="col-filter-icon" [class.active]="hasActiveFilter('additionalContract')"
                    (click)="toggleColumnFilter('additionalContract', $event)">filter_alt</mat-icon>
                </span>
                <ng-container *ngTemplateOutlet="colFilter; context: { col: 'additionalContract' }"></ng-container>
              </th>

              <th *ngIf="isColumnVisible('market')" (click)="sort('market')" [class.active]="sortColumn === 'market'">
                <span class="th-content">
                  Market
                  <span class="material-symbols-outlined arrow-icon">
                    {{ getSortIcon('market') }}
                  </span>
                  <mat-icon class="col-filter-icon" [class.active]="hasActiveFilter('market')"
                    (click)="toggleColumnFilter('market', $event)">filter_alt</mat-icon>
                </span>
                <ng-container *ngTemplateOutlet="colFilter; context: { col: 'market' }"></ng-container>
              </th>

              <th *ngIf="isColumnVisible('marketUnit')" (click)="sort('marketUnit')"
                [class.active]="sortColumn === 'marketUnit'">
                <span class="th-content">
                  Market Unit
                  <span class="material-symbols-outlined arrow-icon">
                    {{ getSortIcon('marketUnit') }}
                  </span>
                  <mat-icon class="col-filter-icon" [class.active]="hasActiveFilter('marketUnit')"
                    (click)="toggleColumnFilter('marketUnit', $event)">filter_alt</mat-icon>
                </span>
                <ng-container *ngTemplateOutlet="colFilter; context: { col: 'marketUnit' }"></ng-container>
              </th>

              <th *ngIf="isColumnVisible('customerRelationship')" (click)="sort('customerRelationship')"
                [class.active]="sortColumn === 'customerRelationship'">
                <span class="th-content">
                  Customer Relationship Name
                  <span class="material-symbols-outlined arrow-icon">
                    {{ getSortIcon('customerRelationship') }}
                  </span>
                  <mat-icon class="col-filter-icon" [class.active]="hasActiveFilter('customerRelationship')"
                    (click)="toggleColumnFilter('customerRelationship', $event)">filter_alt</mat-icon>
                </span>
                <ng-container *ngTemplateOutlet="colFilter; context: { col: 'customerRelationship' }"></ng-container>
              </th>

              <th *ngIf="isColumnVisible('planName')" (click)="sort('planName')"
                [class.active]="sortColumn === 'planName'">
                <span class="th-content">
                  Plan Name
                  <span class="material-symbols-outlined arrow-icon">
                    {{ getSortIcon('planName') }}
                  </span>
                  <mat-icon class="col-filter-icon" [class.active]="hasActiveFilter('planName')"
                    (click)="toggleColumnFilter('planName', $event)">filter_alt</mat-icon>
                </span>
                <ng-container *ngTemplateOutlet="colFilter; context: { col: 'planName' }"></ng-container>
              </th>

              <th *ngIf="isColumnVisible('qadRecommendation')" (click)="sort('qadRecommendation')"
                [class.active]="sortColumn === 'qadRecommendation'">
                <span class="th-content">
                  QAD Recommendation (Opp)/QAD Overall Status (Del)
                  <span class="material-symbols-outlined arrow-icon">
                    {{ getSortIcon('qadRecommendation') }}
                  </span>
                  <mat-icon class="col-filter-icon" [class.active]="hasActiveFilter('qadRecommendation')"
                    (click)="toggleColumnFilter('qadRecommendation', $event)">filter_alt</mat-icon>
                </span>
                <ng-container *ngTemplateOutlet="colFilter; context: { col: 'qadRecommendation' }"></ng-container>
              </th>

              <th *ngIf="isColumnVisible('clientQuality')" (click)="sort('clientQuality')"
                [class.active]="sortColumn === 'clientQuality'">
                <span class="th-content">
                  Client Quality (CQI)
                  <span class="material-symbols-outlined arrow-icon">
                    {{ getSortIcon('clientQuality') }}
                  </span>
                  <mat-icon class="col-filter-icon" [class.active]="hasActiveFilter('clientQuality')"
                    (click)="toggleColumnFilter('clientQuality', $event)">filter_alt</mat-icon>
                </span>
                <ng-container *ngTemplateOutlet="colFilter; context: { col: 'clientQuality' }"></ng-container>
              </th>

              <th *ngIf="isColumnVisible('clientAccLead')" (click)="sort('clientAccLead')"
                [class.active]="sortColumn === 'clientAccLead'">
                <span class="th-content">
                  Client Account Lead (GR)
                  <span class="material-symbols-outlined arrow-icon">
                    {{ getSortIcon('clientAccLead') }}
                  </span>
                  <mat-icon class="col-filter-icon" [class.active]="hasActiveFilter('clientAccLead')"
                    (click)="toggleColumnFilter('clientAccLead', $event)">filter_alt</mat-icon>
                </span>
                <ng-container *ngTemplateOutlet="colFilter; context: { col: 'clientAccLead' }"></ng-container>
              </th>

              <th *ngIf="isColumnVisible('operationsAccLead')" (click)="sort('operationsAccLead')"
                [class.active]="sortColumn === 'operationsAccLead'">
                <span class="th-content">
                  Operation's Account Lead - Overall
                  <span class="material-symbols-outlined arrow-icon">
                    {{ getSortIcon('operationsAccLead') }}
                  </span>
                  <mat-icon class="col-filter-icon" [class.active]="hasActiveFilter('operationsAccLead')"
                    (click)="toggleColumnFilter('operationsAccLead', $event)">filter_alt</mat-icon>
                </span>
                <ng-container *ngTemplateOutlet="colFilter; context: { col: 'operationsAccLead' }"></ng-container>
              </th>

              <th *ngIf="isColumnVisible('masterClientID')" (click)="sort('masterClientID')"
                [class.active]="sortColumn === 'masterClientID'">
                <span class="th-content">
                  Master Client ID
                  <span class="material-symbols-outlined arrow-icon">
                    {{ getSortIcon('masterClientID') }}
                  </span>
                  <mat-icon class="col-filter-icon" [class.active]="hasActiveFilter('masterClientID')"
                    (click)="toggleColumnFilter('masterClientID', $event)">filter_alt</mat-icon>
                </span>
                <ng-container *ngTemplateOutlet="colFilter; context: { col: 'masterClientID' }"></ng-container>
              </th>

              <th *ngIf="isColumnVisible('deliveryCountry')" (click)="sort('deliveryCountry')"
                [class.active]="sortColumn === 'deliveryCountry'">
                <span class="th-content">
                  Delivery Country
                  <span class="material-symbols-outlined arrow-icon">
                    {{ getSortIcon('deliveryCountry') }}
                  </span>
                  <mat-icon class="col-filter-icon" [class.active]="hasActiveFilter('deliveryCountry')"
                    (click)="toggleColumnFilter('deliveryCountry', $event)">filter_alt</mat-icon>
                </span>
                <ng-container *ngTemplateOutlet="colFilter; context: { col: 'deliveryCountry' }"></ng-container>
              </th>

              <th *ngIf="isColumnVisible('locationsToBeReviewed')" (click)="sort('locationsToBeReviewed')"
                [class.active]="sortColumn === 'locationsToBeReviewed'">
                <span class="th-content">
                  Locations to be Reviewed
                  <span class="material-symbols-outlined arrow-icon">
                    {{ getSortIcon('locationsToBeReviewed') }}
                  </span>
                  <mat-icon class="col-filter-icon" [class.active]="hasActiveFilter('locationsToBeReviewed')"
                    (click)="toggleColumnFilter('locationsToBeReviewed', $event)">filter_alt</mat-icon>
                </span>
                <ng-container *ngTemplateOutlet="colFilter; context: { col: 'locationsToBeReviewed' }"></ng-container>
              </th>

              <th *ngIf="isColumnVisible('isPrimaryLocation')" (click)="sort('isPrimaryLocation')"
                [class.active]="sortColumn === 'isPrimaryLocation'">
                <span class="th-content">
                  Is it Primary Location (TBD)?
                  <span class="material-symbols-outlined arrow-icon">
                    {{ getSortIcon('isPrimaryLocation') }}
                  </span>
                  <mat-icon class="col-filter-icon" [class.active]="hasActiveFilter('isPrimaryLocation')"
                    (click)="toggleColumnFilter('isPrimaryLocation', $event)">filter_alt</mat-icon>
                </span>
                <ng-container *ngTemplateOutlet="colFilter; context: { col: 'isPrimaryLocation' }"></ng-container>
              </th>

              <th *ngIf="isColumnVisible('quarter')" (click)="sort('quarter')"
                [class.active]="sortColumn === 'quarter'">
                <span class="th-content">
                  Quarter
                  <span class="material-symbols-outlined arrow-icon">
                    {{ getSortIcon('quarter') }}
                  </span>
                  <mat-icon class="col-filter-icon" [class.active]="hasActiveFilter('quarter')"
                    (click)="toggleColumnFilter('quarter', $event)">filter_alt</mat-icon>
                </span>
                <ng-container *ngTemplateOutlet="colFilter; context: { col: 'quarter' }"></ng-container>
              </th>

              <th *ngIf="isColumnVisible('proposedMonth')" (click)="sort('proposedMonth')"
                [class.active]="sortColumn === 'proposedMonth'">
                <span class="th-content">
                  Proposed Month
                  <span class="material-symbols-outlined arrow-icon">
                    {{ getSortIcon('proposedMonth') }}
                  </span>
                  <mat-icon class="col-filter-icon" [class.active]="hasActiveFilter('proposedMonth')"
                    (click)="toggleColumnFilter('proposedMonth', $event)">filter_alt</mat-icon>
                </span>
                <ng-container *ngTemplateOutlet="colFilter; context: { col: 'proposedMonth' }"></ng-container>
              </th>

              <th *ngIf="isColumnVisible('comments')" (click)="sort('comments')"
                [class.active]="sortColumn === 'comments'">
                <span class="th-content">
                  Comments
                  <span class="material-symbols-outlined arrow-icon">
                    {{ getSortIcon('comments') }}
                  </span>
                  <mat-icon class="col-filter-icon" [class.active]="hasActiveFilter('comments')"
                    (click)="toggleColumnFilter('comments', $event)">filter_alt</mat-icon>
                </span>
                <ng-container *ngTemplateOutlet="colFilter; context: { col: 'comments' }"></ng-container>
              </th>

              <th *ngIf="isColumnVisible('attachment')" (click)="sort('attachment')"
                [class.active]="sortColumn === 'attachment'">
                <span class="th-content">
                  Attachment
                  <span class="material-symbols-outlined arrow-icon">
                    {{ getSortIcon('attachment') }}
                  </span>
                  <mat-icon class="col-filter-icon" [class.active]="hasActiveFilter('attachment')"
                    (click)="toggleColumnFilter('attachment', $event)">filter_alt</mat-icon>
                </span>
                <ng-container *ngTemplateOutlet="colFilter; context: { col: 'attachment' }"></ng-container>
              </th>

              <th *ngIf="isColumnVisible('notes/instructions')" (click)="sort('notes/instructions')"
                [class.active]="sortColumn === 'notes/instructions'">
                <span class="th-content">
                  Notes/Instructions
                  <span class="material-symbols-outlined arrow-icon">
                    {{ getSortIcon('notes/instructions') }}
                  </span>
                  <mat-icon class="col-filter-icon" [class.active]="hasActiveFilter('notes/instructions')"
                    (click)="toggleColumnFilter('notes/instructions', $event)">filter_alt</mat-icon>
                </span>
                <ng-container *ngTemplateOutlet="colFilter; context: { col: 'notes/instructions' }"></ng-container>
              </th>

              <th *ngIf="isColumnVisible('createdBy')" (click)="sort('createdBy')"
                [class.active]="sortColumn === 'createdBy'">
                <span class="th-content">
                  Created By
                  <span class="material-symbols-outlined arrow-icon">
                    {{ getSortIcon('createdBy') }}
                  </span>
                  <mat-icon class="col-filter-icon" [class.active]="hasActiveFilter('createdBy')"
                    (click)="toggleColumnFilter('createdBy', $event)">filter_alt</mat-icon>
                </span>
                <ng-container *ngTemplateOutlet="colFilter; context: { col: 'createdBy' }"></ng-container>
              </th>

              <th *ngIf="isColumnVisible('createdDate')" (click)="sort('createdDate')"
                [class.active]="sortColumn === 'createdDate'">
                <span class="th-content">
                  Created Date
                  <span class="material-symbols-outlined arrow-icon">
                    {{ getSortIcon('createdDate') }}
                  </span>
                  <mat-icon class="col-filter-icon" [class.active]="hasActiveFilter('createdDate')"
                    (click)="toggleColumnFilter('createdDate', $event)">filter_alt</mat-icon>
                </span>
                <ng-container *ngTemplateOutlet="colFilter; context: { col: 'createdDate' }"></ng-container>
              </th>

              <th *ngIf="isColumnVisible('rcManager')" (click)="sort('rcManager')"
                [class.active]="sortColumn === 'rcManager'">
                <span class="th-content">
                  R&C Manager
                  <span class="material-symbols-outlined arrow-icon">
                    {{ getSortIcon('rcManager') }}
                  </span>
                  <mat-icon class="col-filter-icon" [class.active]="hasActiveFilter('rcManager')"
                    (click)="toggleColumnFilter('rcManager', $event)">filter_alt</mat-icon>
                </span>
                <ng-container *ngTemplateOutlet="colFilter; context: { col: 'rcManager' }"></ng-container>
              </th>

              <th *ngIf="isColumnVisible('rcSupervisor')" (click)="sort('rcSupervisor')"
                [class.active]="sortColumn === 'rcSupervisor'">
                <span class="th-content">
                  R&C Supervisor
                  <span class="material-symbols-outlined arrow-icon">
                    {{ getSortIcon('rcSupervisor') }}
                  </span>
                  <mat-icon class="col-filter-icon" [class.active]="hasActiveFilter('rcSupervisor')"
                    (click)="toggleColumnFilter('rcSupervisor', $event)">filter_alt</mat-icon>
                </span>
                <ng-container *ngTemplateOutlet="colFilter; context: { col: 'rcSupervisor' }"></ng-container>
              </th>

              <th *ngIf="isColumnVisible('rcReviewer')" (click)="sort('rcReviewer')"
                [class.active]="sortColumn === 'rcReviewer'">
                <span class="th-content">
                  R&C Reviewer
                  <span class="material-symbols-outlined arrow-icon">
                    {{ getSortIcon('rcReviewer') }}
                  </span>
                  <mat-icon class="col-filter-icon" [class.active]="hasActiveFilter('rcReviewer')"
                    (click)="toggleColumnFilter('rcReviewer', $event)">filter_alt</mat-icon>
                </span>
                <ng-container *ngTemplateOutlet="colFilter; context: { col: 'rcReviewer' }"></ng-container>
              </th>

              <th *ngIf="isColumnVisible('secondaryManager')" (click)="sort('secondaryManager')"
                [class.active]="sortColumn === 'secondaryManager'">
                <span class="th-content">
                  Secondary Manager
                  <span class="material-symbols-outlined arrow-icon">
                    {{ getSortIcon('secondaryManager') }}
                  </span>
                  <mat-icon class="col-filter-icon" [class.active]="hasActiveFilter('secondaryManager')"
                    (click)="toggleColumnFilter('secondaryManager', $event)">filter_alt</mat-icon>
                </span>
                <ng-container *ngTemplateOutlet="colFilter; context: { col: 'secondaryManager' }"></ng-container>
              </th>

              <th *ngIf="isColumnVisible('secondarySupervisor')" (click)="sort('secondarySupervisor')"
                [class.active]="sortColumn === 'secondarySupervisor'">
                <span class="th-content">
                  Secondary Supervisor
                  <span class="material-symbols-outlined arrow-icon">
                    {{ getSortIcon('secondarySupervisor') }}
                  </span>
                  <mat-icon class="col-filter-icon" [class.active]="hasActiveFilter('secondarySupervisor')"
                    (click)="toggleColumnFilter('secondarySupervisor', $event)">filter_alt</mat-icon>
                </span>
                <ng-container *ngTemplateOutlet="colFilter; context: { col: 'secondarySupervisor' }"></ng-container>
              </th>

              <th *ngIf="isColumnVisible('secondaryReviewer')" (click)="sort('secondaryReviewer')"
                [class.active]="sortColumn === 'secondaryReviewer'">
                <span class="th-content">
                  Secondary Reviewer
                  <span class="material-symbols-outlined arrow-icon">
                    {{ getSortIcon('secondaryReviewer') }}
                  </span>
                  <mat-icon class="col-filter-icon" [class.active]="hasActiveFilter('secondaryReviewer')"
                    (click)="toggleColumnFilter('secondaryReviewer', $event)">filter_alt</mat-icon>
                </span>
                <ng-container *ngTemplateOutlet="colFilter; context: { col: 'secondaryReviewer' }"></ng-container>
              </th>

              <th *ngIf="isColumnVisible('scheduleID')" (click)="sort('scheduleID')"
                [class.active]="sortColumn === 'scheduleID'">
                <span class="th-content">
                  Schedule ID
                  <span class="material-symbols-outlined arrow-icon">
                    {{ getSortIcon('scheduleID') }}
                  </span>
                  <mat-icon class="col-filter-icon" [class.active]="hasActiveFilter('scheduleID')"
                    (click)="toggleColumnFilter('scheduleID', $event)">filter_alt</mat-icon>
                </span>
                <ng-container *ngTemplateOutlet="colFilter; context: { col: 'scheduleID' }"></ng-container>
              </th>

              <th *ngIf="isColumnVisible('accentureOperationsSL')" (click)="sort('accentureOperationsSL')"
                [class.active]="sortColumn === 'accentureOperationsSL'">
                <span class="th-content">
                  Accenture Operation Service Line
                  <span class="material-symbols-outlined arrow-icon">
                    {{ getSortIcon('accentureOperationsSL') }}
                  </span>
                  <mat-icon class="col-filter-icon" [class.active]="hasActiveFilter('accentureOperationsSL')"
                    (click)="toggleColumnFilter('accentureOperationsSL', $event)">filter_alt</mat-icon>
                </span>
                <ng-container *ngTemplateOutlet="colFilter; context: { col: 'accentureOperationsSL' }"></ng-container>
              </th>

              <th *ngIf="isColumnVisible('parentChild')" (click)="sort('parentChild')"
                [class.active]="sortColumn === 'parentChild'">
                <span class="th-content">
                  Parent/Child (TBD)
                  <span class="material-symbols-outlined arrow-icon">
                    {{ getSortIcon('parentChild') }}
                  </span>
                  <mat-icon class="col-filter-icon" [class.active]="hasActiveFilter('parentChild')"
                    (click)="toggleColumnFilter('parentChild', $event)">filter_alt</mat-icon>
                </span>
                <ng-container *ngTemplateOutlet="colFilter; context: { col: 'parentChild' }"></ng-container>
              </th>

              <th *ngIf="isColumnVisible('parentReviewID')" (click)="sort('parentReviewID')"
                [class.active]="sortColumn === 'parentReviewID'">
                <span class="th-content">
                  Parent Review ID (TBD)
                  <span class="material-symbols-outlined arrow-icon">
                    {{ getSortIcon('parentReviewID') }}
                  </span>
                  <mat-icon class="col-filter-icon" [class.active]="hasActiveFilter('parentReviewID')"
                    (click)="toggleColumnFilter('parentReviewID', $event)">filter_alt</mat-icon>
                </span>
                <ng-container *ngTemplateOutlet="colFilter; context: { col: 'parentReviewID' }"></ng-container>
              </th>

              <th *ngIf="isColumnVisible('targetReportPublication')" (click)="sort('targetReportPublication')"
                [class.active]="sortColumn === 'targetReportPublication'">
                <span class="th-content">
                  Target for report publications
                  <span class="material-symbols-outlined arrow-icon">
                    {{ getSortIcon('targetReportPublication') }}
                  </span>
                  <mat-icon class="col-filter-icon" [class.active]="hasActiveFilter('targetReportPublication')"
                    (click)="toggleColumnFilter('targetReportPublication', $event)">filter_alt</mat-icon>
                </span>
                <ng-container *ngTemplateOutlet="colFilter; context: { col: 'targetReportPublication' }"></ng-container>
              </th>

              <th *ngIf="isColumnVisible('fieldWorkStartDate')" (click)="sort('fieldWorkStartDate')"
                [class.active]="sortColumn === 'fieldWorkStartDate'">
                <span class="th-content">
                  Field Work Start Date
                  <span class="material-symbols-outlined arrow-icon">
                    {{ getSortIcon('fieldWorkStartDate') }}
                  </span>
                  <mat-icon class="col-filter-icon" [class.active]="hasActiveFilter('fieldWorkStartDate')"
                    (click)="toggleColumnFilter('fieldWorkStartDate', $event)">filter_alt</mat-icon>
                </span>
                <ng-container *ngTemplateOutlet="colFilter; context: { col: 'fieldWorkStartDate' }"></ng-container>
              </th>

              <th *ngIf="isColumnVisible('fieldWorkEndDate')" (click)="sort('fieldWorkEndDate')"
                [class.active]="sortColumn === 'fieldWorkEndDate'">
                <span class="th-content">
                  Field Work End Date
                  <span class="material-symbols-outlined arrow-icon">
                    {{ getSortIcon('fieldWorkEndDate') }}
                  </span>
                  <mat-icon class="col-filter-icon" [class.active]="hasActiveFilter('fieldWorkEndDate')"
                    (click)="toggleColumnFilter('fieldWorkEndDate', $event)">filter_alt</mat-icon>
                </span>
                <ng-container *ngTemplateOutlet="colFilter; context: { col: 'fieldWorkEndDate' }"></ng-container>
              </th>

              <th *ngIf="isColumnVisible('singleOrMultiLocation')" (click)="sort('singleOrMultiLocation')"
                [class.active]="sortColumn === 'singleOrMultiLocation'">
                <span class="th-content">
                  Single or Multiple Location Review? (TBD)
                  <span class="material-symbols-outlined arrow-icon">
                    {{ getSortIcon('singleOrMultiLocation') }}
                  </span>
                  <mat-icon class="col-filter-icon" [class.active]="hasActiveFilter('singleOrMultiLocation')"
                    (click)="toggleColumnFilter('singleOrMultiLocation', $event)">filter_alt</mat-icon>
                </span>
                <ng-container *ngTemplateOutlet="colFilter; context: { col: 'singleOrMultiLocation' }"></ng-container>
              </th>
              <th class="action-col">Action</th>
            </tr>
          </thead>

          <!-- Shared column filter popup template -->
          <ng-template #colFilter let-col="col">
            <div class="col-filter-popup" *ngIf="activeFilterColumn === col" (click)="$event.stopPropagation()">
              <select [(ngModel)]="filters[col].op1">
                <option *ngFor="let op of operators" [value]="op">{{op}}</option>
              </select>
              <input type="text" [(ngModel)]="filters[col].val1" placeholder="Filter..." />
              <div class="popup-actions">
                <button type="button" class="btn-reset" (click)="resetFilter(col)">Reset</button>
                <button type="button" class="btn-apply" (click)="applyFilter()">Apply</button>
              </div>
            </div>
          </ng-template>

          <tbody>

            <tr *ngIf="filteredData().length === 0">
              <td [attr.colspan]="visibleColumnCount()" class="no-data-message">
                No Data Found
              </td>
            </tr>

            <tr *ngFor="let item of filteredData() | slice:(currentPage-1)*pageSize:(currentPage)*pageSize">
              <td *ngIf="isColumnVisible('id')" class="link">{{item.id}}</td>
              <td *ngIf="isColumnVisible('name')">{{item.name}}</td>
              <td *ngIf="isColumnVisible('employee')">{{item.employee}}</td>
              <td *ngIf="isColumnVisible('status')">{{item.status}}</td>
              <td *ngIf="isColumnVisible('year')">{{item.year}}</td>
              <td *ngIf="isColumnVisible('client')">{{item.client}}</td>
              <td *ngIf="isColumnVisible('project')">{{item.project}}</td>
              <td *ngIf="isColumnVisible('contract')">{{item.contract}}</td>
              <td *ngIf="isColumnVisible('additionalContract')">{{item.additionalContract}}</td>
              <td *ngIf="isColumnVisible('market')">{{item.market}}</td>
              <td *ngIf="isColumnVisible('marketUnit')">{{item.marketUnit}}</td>
              <td *ngIf="isColumnVisible('customerRelationship')">{{item.customerRelationship}}</td>
              <td *ngIf="isColumnVisible('planName')">{{item.planName}}</td>
              <td *ngIf="isColumnVisible('qadRecommendation')">{{item.qadRecommendation}}</td>
              <td *ngIf="isColumnVisible('clientQuality')">{{item.clientQuality}}</td>
              <td *ngIf="isColumnVisible('clientAccLead')">{{item.clientAccLead}}</td>
              <td *ngIf="isColumnVisible('operationsAccLead')">{{item.operationsAccLead}}</td>
              <td *ngIf="isColumnVisible('masterClientID')">{{item.masterClientID}}</td>
              <td *ngIf="isColumnVisible('deliveryCountry')">{{item.deliveryCountry}}</td>
              <td *ngIf="isColumnVisible('locationsToBeReviewed')">{{item.locationsToBeReviewed}}</td>
              <td *ngIf="isColumnVisible('isPrimaryLocation')">{{item.isPrimaryLocation}}</td>
              <td *ngIf="isColumnVisible('quarter')">{{item.quarter}}</td>
              <td *ngIf="isColumnVisible('proposedMonth')">{{item.proposedMonth}}</td>
              <td *ngIf="isColumnVisible('comments')">{{item.comments}}</td>
              <td *ngIf="isColumnVisible('attachment')">
                <ng-container *ngFor="let doc of parseAttachmentDocs(item.attachment); let last = last">
                  <a class="attachment-link attachment-link--downloadable" (click)="downloadAttachment(doc, item.id)" [title]="doc.fileName" style="cursor:pointer">{{ doc.fileName }}</a>
                  <br *ngIf="!last" />
                </ng-container>
              </td>
              <td *ngIf="isColumnVisible('notes/instructions')">{{item['notes/instructions']}}</td>
              <td *ngIf="isColumnVisible('createdBy')">{{item.createdBy}}</td>
              <td *ngIf="isColumnVisible('createdDate')">{{item.createdDate}}</td>
              <td *ngIf="isColumnVisible('rcManager')">{{item.rcManager}}</td>
              <td *ngIf="isColumnVisible('rcSupervisor')">{{item.rcSupervisor}}</td>
              <td *ngIf="isColumnVisible('rcReviewer')">{{item.rcReviewer}}</td>
              <td *ngIf="isColumnVisible('secondaryManager')">{{item.secondaryManager}}</td>
              <td *ngIf="isColumnVisible('secondarySupervisor')">{{item.secondarySupervisor}}</td>
              <td *ngIf="isColumnVisible('secondaryReviewer')">{{item.secondaryReviewer}}</td>
              <td *ngIf="isColumnVisible('scheduleID')">{{item.scheduleID}}</td>
              <td *ngIf="isColumnVisible('accentureOperationsSL')">{{item.accentureOperationsSL}}</td>
              <td *ngIf="isColumnVisible('parentChild')">{{item.parentChild}}</td>
              <td *ngIf="isColumnVisible('parentReviewID')">{{item.parentReviewID}}</td>
              <td *ngIf="isColumnVisible('targetReportPublication')">{{item.targetReportPublication}}</td>
              <td *ngIf="isColumnVisible('fieldWorkStartDate')">{{item.fieldWorkStartDate}}</td>
              <td *ngIf="isColumnVisible('fieldWorkEndDate')">{{item.fieldWorkEndDate}}</td>
              <td *ngIf="isColumnVisible('singleOrMultiLocation')">{{item.singleOrMultiLocation}}</td>

              <td class="actions action-col">
                <span *ngIf="item.status === 'Draft'" class="material-symbols-outlined status-icon" (click)="(isAdmin || isUserInRowRoles(item)) ? openReview(item) : null" [class.icon-disabled]="!(isAdmin || isUserInRowRoles(item))"
                  [title]="(isAdmin || isUserInRowRoles(item)) ? 'Draft' : 'Access is not provided.'">play_circle</span>
                <span *ngIf="item.status && item.status !== 'Draft'" class="material-symbols-outlined status-icon" [title]="(isAdmin || isUserInRowRoles(item)) ? item.status : 'Access is not provided.'" (click)="(isAdmin || isUserInRowRoles(item)) ? openReview(item) : null"
                 [class.icon-disabled]="!(isAdmin || isUserInRowRoles(item))">arrow_circle_right</span>
                <span class="material-symbols-outlined view-icon" title="View" (click)="openView(item)">visibility</span>
                <span class="material-symbols-outlined edit-icon" [class.icon-disabled]="!(isAdmin || isUserInRowRoles(item))" (click)="(isAdmin || isUserInRowRoles(item)) ? openEdit(item) : null" [title]="(isAdmin || isUserInRowRoles(item)) ? 'Edit' : 'Access is not provided.'">edit_square</span>
                <span
                  class="material-symbols-outlined delete-icon"
                  [class.icon-disabled]="!isAdmin"
                  [title]="isAdmin ? 'Delete' : 'Only Admin has access to Delete'"
                  (click)="isAdmin ? openDeleteModal(item) : null">delete</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="pagination">
        <span>Show</span>
        <select [(ngModel)]="pageSize" (change)="currentPage=1">
          <option *ngFor="let size of [10,25,50]" [value]="size">{{size}}</option>
        </select>

        <span>Items/page</span>
        <span>Go to page</span>
        <input type="number" [(ngModel)]="goToPageInput" (keyup.enter)="goToPage()" (change)="goToPage()" min="1" [max]="totalPages()"
          class="goto-input" />

        <button class="arrow" (click)="firstPage()" [disabled]="currentPage === 1">&#171;</button>
        <button class="arrow" (click)="prevPage()" [disabled]="currentPage === 1">&#8249;</button>

        <button *ngFor="let page of totalPagesArray()" [class.active]="page === currentPage"
          (click)="currentPage = page">
          {{page}}
        </button>

        <button class="arrow" (click)="nextPage()" [disabled]="currentPage === totalPages()">&#8250;</button>
        <button class="arrow" (click)="lastPage()" [disabled]="currentPage === totalPages()">&#187;</button>
      </div>
    </section>
  </main>
</div>

<!-- Delete Confirmation Modal -->
<div class="delete-modal-overlay" *ngIf="showDeleteModal" (click)="closeDeleteModal()">
  <div class="delete-modal" (click)="$event.stopPropagation()">
    <h2 class="delete-modal-title">Delete Review</h2>
    <p class="delete-modal-body">Are you sure you want to delete this review?</p>
    <div class="delete-modal-actions">
      <button type="button" class="delete-modal-cancel" (click)="closeDeleteModal()">Cancel</button>
      <button type="button" class="delete-modal-confirm" [disabled]="isDeletingReview" (click)="confirmDelete()">Confirm Delete</button>
    </div>
  </div>
</div>